/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading, camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { withDynamicImport } from '@thd-nucleus/app-render';
import { Skeleton, SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';
import { useHydratedProps, withLayout, withLayoutAccordion, mergeProductClientOnlyProduct }
from '@thd-olt-component-react/fusion-utils';

import { RulesMiddleware as RulesMiddleware_MiddlewareSlot
  , withDynamicBundleAccordion } from '@thd-olt-component-middleware/pip';

import { BundleProductDetails as BundleProductDetailsSSR, BundleSpecifications as BundleSpecificationsSSR } from '@thd-olt-component-react/product-bundle?clientSideRemove';

import { QuestionsAndAnswersAccordionBody as QuestionsAndAnswersAccordionBodySSR } from '@thd-olt-component-react/questions-and-answers?clientSideRemove';

import { RatingsAndReviewsAccordionBody as RatingsAndReviewsAccordionBodySSR } from '@thd-olt-component-react/ratings-and-reviews?clientSideRemove';

import { BundleProductOverviewAccordionTitle as BundleProductOverviewAccordionTitleSlotG1Index0K0Header, BundleSpecificationsAccordionTitle as BundleSpecificationsAccordionTitleSlotG1Index1K0Header }
from '@thd-olt-component-react/product-bundle';

import { QuestionsAndAnswersAccordionTitle as QuestionsAndAnswersAccordionTitleSlotG1Index2K0Header }
from '@thd-olt-component-react/questions-and-answers';

import { RatingsAndReviewsAccordionTitle as RatingsAndReviewsAccordionTitleSlotG1Index3K0Header }
from '@thd-olt-component-react/ratings-and-reviews';

const lazySlots = {};
const getPlaceholder = ({ skip }) => {
  if (skip) return null;
  return (
    <Skeleton>
      <SkeletonBlock />
      <SkeletonLine />
    </Skeleton>
  );
};

const SlotG1Placeholder0K0 = null;

const SlotG1Index0ClientK0 = () => {
  return import(
    '@thd-olt-component-react/product-bundle');
};

export const SlotG1Index0LoadK0 = withDynamicImport({
  server: () => {
    return BundleProductDetailsSSR;
  },
  client: SlotG1Index0ClientK0,
  placeholder: SlotG1Placeholder0K0 || getPlaceholder({ skip: true }),
  name: 'BundleProductDetails',
});

lazySlots.LazySlotG1KBody1 = withLayout(
  SlotG1Index0LoadK0,

  null
  ,
  {
    waitForComponent: SlotG1Index0ClientK0,
    placeholder: SlotG1Placeholder0K0 || getPlaceholder({ skip: true })
  }
);

const SlotG1Placeholder1K0 = null;

const SlotG1Index1ClientK0 = () => {
  return import(
    '@thd-olt-component-react/product-bundle');
};

export const SlotG1Index1LoadK0 = withDynamicImport({
  server: () => {
    return BundleSpecificationsSSR;
  },
  client: SlotG1Index1ClientK0,
  placeholder: SlotG1Placeholder1K0 || getPlaceholder({ skip: true }),
  name: 'BundleSpecifications',
});

lazySlots.LazySlotG1KBody2 = withLayout(
  SlotG1Index1LoadK0,

  null
  ,
  {
    waitForComponent: SlotG1Index1ClientK0,
    placeholder: SlotG1Placeholder1K0 || getPlaceholder({ skip: true })
  }
);

const SlotG1Placeholder2K0 = null;

const SlotG1Index2ClientK0 = () => {
  return import(
    '@thd-olt-component-react/questions-and-answers');
};

export const SlotG1Index2LoadK0 = withDynamicImport({
  server: () => {
    return QuestionsAndAnswersAccordionBodySSR;
  },
  client: SlotG1Index2ClientK0,
  placeholder: SlotG1Placeholder2K0 || getPlaceholder({ skip: true }),
  name: 'QuestionsAndAnswersAccordionBody',
});

lazySlots.LazySlotG1KBody3 = withLayout(
  SlotG1Index2LoadK0,

  null
  ,
  {
    waitForComponent: SlotG1Index2ClientK0,
    placeholder: SlotG1Placeholder2K0 || getPlaceholder({ skip: true })
  }
);

const SlotG1Placeholder3K0 = null;

const SlotG1Index3ClientK0 = () => {
  return import(
    '@thd-olt-component-react/ratings-and-reviews');
};

export const SlotG1Index3LoadK0 = withDynamicImport({
  server: () => {
    return RatingsAndReviewsAccordionBodySSR;
  },
  client: SlotG1Index3ClientK0,
  placeholder: SlotG1Placeholder3K0 || getPlaceholder({ skip: true }),
  name: 'RatingsAndReviewsAccordionBody',
});

lazySlots.LazySlotG1KBody4 = withLayout(
  SlotG1Index3LoadK0,

  null
  ,
  {
    waitForComponent: SlotG1Index3ClientK0,
    placeholder: SlotG1Placeholder3K0 || getPlaceholder({ skip: true })
  }
);

let RulesMiddleware_MiddlewareSlot_SlotG1 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_SlotG1 = withDynamicBundleAccordion(RulesMiddleware_MiddlewareSlot_SlotG1, { render: [{ name: 'QuestionsAndAnswersAccordionTitle' }, { name: 'RatingsAndReviewsAccordionTitle' }] });

const LazySlotG1Accordion = withLayoutAccordion([
  [

    [

      withLayout(
        BundleProductOverviewAccordionTitleSlotG1Index0K0Header,

      ),

    ],

    [

      withLayout(
        BundleSpecificationsAccordionTitleSlotG1Index1K0Header,

      ),

    ],

    [

      withLayout(
        QuestionsAndAnswersAccordionTitleSlotG1Index2K0Header,

      ),

    ],

    [

      withLayout(
        RatingsAndReviewsAccordionTitleSlotG1Index3K0Header,

      ),

    ],

  ],
  [

    [

      lazySlots.LazySlotG1KBody1,

    ],

    [

      lazySlots.LazySlotG1KBody2,

    ],

    [

      lazySlots.LazySlotG1KBody3,

    ],

    [

      lazySlots.LazySlotG1KBody4,

    ],

  ]
],

RulesMiddleware_MiddlewareSlot_SlotG1
);

// to be generated by ejs based on config
export const DynamicImporter = (props) => {
  const { storeId, storeZip } = useStore();
  const slot = props.config.slots[props.slot];
  const components = slot.isAccordion
    ? slot.components.flat().map((sc) => sc.components).flat()
    : slot.components.flat();

  // todo use merge option?
  const hydratedProps = useHydratedProps(components, { itemId: props.itemId });
  components.forEach((com, index) => {
    // eslint-disable-next-line no-param-reassign
    com.props = hydratedProps[index];
  });

  const merge = mergeProductClientOnlyProduct;

  // use this for debugging, attache to queryProvider prop

  // const queryOptions = ({ options, queryName }) => {
  //   return {
  //     ...options,
  //     fetchPolicy: 'cache-only'
  //   };
  // };

  const ssr = typeof window === 'undefined';
  const decisionIndex = ssr
    ? 0
    : Number(
      (window.__SLOT_DECISIONS__ && window.__SLOT_DECISIONS__[props.slot]) ?? '0'
    );

  if (props.slot === 'SlotG1') {

    return (
      <LazySlotG1Accordion
        {...props}
        config={props.config}
        fusionSlotName="SlotG1"
        fusionComponentName="accordion"
        fusionClassName={slot.fusionClassName}
        isDynamic
        // commenting inner query provider since withDynamicImport already wraps AccordionBody with inner query provider
        // queryProvider={{
        //   inherit: 'page',
        //   merge,
        //   queryOptions,
        //   cache key for all accordions must be the same
        //   otherwise a race condition will occur generating duplicate requests
        //   cacheKey: 'page',
        //   defaultVariables: props?.qctx?.defaultVariables?.current || { storeId, zipCode: storeZip }
        // }}
      />
    );

  }

  return null;
};

DynamicImporter.propTypes = {
  config: PropTypes.shape({
    slots: PropTypes.shape({})
  }).isRequired,
  slot: PropTypes.string.isRequired,
};